import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { Fill, Icon, Stroke, Style } from "ol/style";
import IconAnchorUnits from "ol/style/IconAnchorUnits";
import measurementIcon from "~/assets/img/measurement_marker.svg";
import { LayerDefaults, LayerTitle } from "../types/layers";
import { SeaSurveyMapItem } from "../types/mapItems";
import { readMapSettings } from "./localMapSettings";

interface Return {
  source: VectorSource;
  layer: VectorLayer;
}

const resolutionStyleCache: {
  [key: string]: Style;
} = {};

function createMeasurementsLayer(): Return {
  const source = new VectorSource();
  const title = LayerTitle.Measurements;
  const icon = `${window.location.origin}${measurementIcon}`;
  const layer = new VectorLayer({
    source,
    zIndex:
      readMapSettings("layers", title)?.zIndex ?? LayerDefaults[title].zIndex,
    visible:
      readMapSettings("layers", title)?.visible ?? LayerDefaults[title].visible,
    renderBuffer: 100000,
    style: (feat, resolution) => {
      // Show icon on higher resolutions and boundary on smaller resolutions
      const survey = feat.getProperties() as SeaSurveyMapItem;
      const resolutionCutOff = resolution < 7;

      const showBoundary =
        survey.hasBoundary &&
        resolutionCutOff &&
        readMapSettings("surveyOutlines");
      const markerStyle = new Style({
        image: new Icon({
          opacity: 1,
          src: icon,
          scale: 1.5,
          offset: [0, 0],
          anchor: [0.5, 24],
          anchorXUnits: IconAnchorUnits.FRACTION,
          anchorYUnits: IconAnchorUnits.PIXELS,
        }),
      });

      const style = showBoundary
        ? resolutionStyleCache[resolution]
        : markerStyle;

      if (style) {
        return style;
      }
      const styleForCache = new Style({
        geometry: "multiPolygon",
        fill: new Fill({
          color: "rgba(255, 255, 255, 0.2)",
        }),
        stroke: new Stroke({
          color: "#9C27B0",
          width: 2,
        }),
      });
      resolutionStyleCache[resolution] = styleForCache;
      return styleForCache;
    },
  });
  layer.set("title", title);

  return { source, layer };
}

export default createMeasurementsLayer;
